// should be used from ioContext
export function getTimezoneAbbreviation(date, timeZone) {
  var _navigator, _parts$find;
  const preferred = (_navigator = navigator) === null || _navigator === void 0 ? void 0 : _navigator.language;
  const locale = Intl.DateTimeFormat.supportedLocalesOf(preferred)[0] || 'en-US';
  const parts = new Intl.DateTimeFormat(locale, {
    timeZoneName: 'short',
    timeZone
  }).formatToParts(date);
  const tzAbbr = (_parts$find = parts.find(p => p.type === 'timeZoneName')) === null || _parts$find === void 0 ? void 0 : _parts$find.value;
  if (!tzAbbr) return null;

  //this regex is to handle the case where the timezone abbreviation is in GMT format
  //in that case i want to convert it to UTC (GMT is the same as UTC just a different name)
  if (/^GMT[+-]/.test(tzAbbr)) {
    return tzAbbr.replace(/^GMT/, 'UTC');
  }
  return tzAbbr;
}